import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useInquiry } from "@/context/InquiryContext";

export default function ProductCard({ p, index = 0 }) {
  const { openQuote } = useInquiry();

  return (
    <div
      data-testid={`product-card-${p.slug}`}
      className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white transition duration-300 hover:-translate-y-1 hover:border-rose-200 hover:shadow-xl hover:shadow-slate-200/60"
    >
      <Link to={`/products/${p.slug}`} className="relative block aspect-[4/3] overflow-hidden bg-slate-100">
        <img
          src={p.image}
          alt={p.name}
          loading="lazy"
          className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded bg-navy/85 px-2 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-rose-300">
          KSC-{String(index + 1).padStart(2, "0")}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-display text-lg font-bold tracking-tight text-slate-900">{p.name}</h3>
        <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-slate-600">{p.tagline}</p>
        <div className="mt-auto flex items-center justify-between pt-5">
          <Link
            to={`/products/${p.slug}`}
            className="inline-flex items-center gap-1 text-sm font-semibold text-safety transition hover:text-safety-dark"
          >
            View Details <ArrowUpRight size={15} />
          </Link>
          <button
            data-testid={`ask-price-${p.slug}`}
            onClick={() => openQuote(p.name)}
            className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-600 transition hover:border-safety hover:text-safety"
          >
            Ask Price
          </button>
        </div>
      </div>
    </div>
  );
}
